// how often do we measure, e.g. every 100th scroll
export const DEFAULT_SAMPLING_RATE = 100;

// how many frames we measure in order to calculate FPS
export const FRAMES_LIMIT = 20;

// FPS target
export const MAX_FPS = 60;
